import { render } from "./MailIcon.vue?vue&type=template&id=32ebe4c9&scoped=true"
import script from "./MailIcon.vue?vue&type=script&lang=js"
export * from "./MailIcon.vue?vue&type=script&lang=js"

import "./MailIcon.vue?vue&type=style&index=0&id=32ebe4c9&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ebe4c9"]])

export default __exports__